import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "modal-header-basic",
	template: `<div class="modal-header">basic header</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["../headers.component.scss"],
	standalone: false
})
export class BasicHeaderComponent {}
